export default "__VITE_ASSET__B8Hl3yaq__"